import React, { useState } from 'react';
import './GridCell.css';

function GridCell({ row, col, plantCount, onClick, selected, onDrop }) {
  const [dragOver, setDragOver] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick(row, col);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const plantId = e.dataTransfer.getData('text/plant-id');
    if (plantId && onDrop) {
      onDrop(plantId, row, col);
    }
  };

  const classNames = ['grid-cell'];
  if (selected) {
    classNames.push('grid-cell--selected');
  }
  if (plantCount > 0) {
    classNames.push('grid-cell--has-plants');
  }
  if (dragOver) {
    classNames.push('grid-cell--drag-over');
  }

  const ariaLabel = `Grid cell row ${row}, column ${col}, ${plantCount} plants`;

  return (
    <div
      className={classNames.join(' ')}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      aria-pressed={selected}
    >
      {plantCount > 0 ? (
        <span className="grid-cell__badge">{plantCount}</span>
      ) : (
        <span className="grid-cell__empty" />
      )}
    </div>
  );
}

export default GridCell;
